'use client';

import { LanguageContextProvider } from '@unifyapps/i18n/context/LanguageProvider';
import { fallbackLng } from '@unifyapps/i18n/settings';
import { preloadDayPickerLocale } from '@unifyapps/ui/_components/DatePicker/hooks/useDayPickerLocale';
import { type PropsWithChildren, useEffect } from 'react';
import { useUserStore } from '../auth/UserStoreProvider';

function LocaleProvider({ children, locale }: PropsWithChildren<{ locale?: string }>) {
  const lng = useUserStore().hooks.useCurrentUserDetails()?.user?.locale ?? fallbackLng;
  const language = locale ?? lng;

  useEffect(() => {
    preloadDayPickerLocale(language);
  }, [language]);

  return <LanguageContextProvider value={language}>{children}</LanguageContextProvider>;
}

export default LocaleProvider;
